<template>
    <g-base-box padding="p-0">
        <div v-for="(value, key, index) in data" :key="index" class="table-row">
            <g-typography class="table-row__key g-p-5" :font-weight="index === 0 ? 'bold' : 'normal'">
                {{ key }}
            </g-typography>
            <g-typography class="table-row__value g-p-5" font-weight="bold">{{ value }}</g-typography>
            <g-divider v-if="index !== Object.keys(data).length - 1" margin="none" />
        </div>
    </g-base-box>
</template>

<script>
    export default {
        name: 'KeyValueDataTable',
        props: {
            data: {
                type: Object,
                default: null
            }
        }
    }
</script>

<style lang="scss" scoped>
    .table-row {
        .table-row__key {
            float: left;
        }
        .table-row__value {
            float: right;
        }
    }
</style>
